import { Routes, Route } from "react-router-dom";
import HomePage from "./screen/HomePage";
import Achievers from "./screen/Achievers";
import Layout from "./Layout/Layout";
import { Toaster } from "react-hot-toast";

import "flag-icons/css/flag-icons.min.css";
import BookATable from "screen/BookATable";
import Menu from "./screen/Menu";
import CartMenu from "./screen/CartMenu";
import AuthModal from "components/AuthModal/AuthModal";
import SessionExpiredModal from "./components/SectionExpiredModal/SectionExpiredModal";
import ProtectedRoute from "components/ProtectedRoute/ProtectedRoute";

function App() {
  return (
    <>
      <Toaster position="bottom-left" />
      <AuthModal />
      <SessionExpiredModal />

      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />

          <Route path="/bookatable" element={<BookATable />} />
          <Route
            path="/menu"
            element={
              // <ProtectedRoute>
              <Menu />
              // </ProtectedRoute>
            }
          />
          <Route path="/cart" element={<CartMenu />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;
